import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { usePriceList } from "../../providers/PriceListProvider";
import { useHistory, useLocation } from "../../hooks/useRoutes";

export const getUniqueValuesByKey = (list, key) => {
  console.log("Get unique ", list);
  return list
    .reduce((products, template) => {
      let values;
      console.log("Type of", typeof key);
      if (typeof key == "function") {
        values = key(template);
      } else {
        values = template[key];
      }

      if (typeof values !== "object") {
        values = [values];
      }
      console.log("Iterate over", values);
      for (const value of values) {
        if (value === "") {
          continue;
        }
        if (products.indexOf(value) < 0) {
          products.push(value);
        }
      }
      return products;
    }, [])
    .sort((a, b) => {
      console.log("A", a);
      return a.toString().localeCompare(b.toString(), undefined, {
        numeric: true,
        sensitivity: "base",
      });
    });
};

const isChecked = (key, predef, value) => {
  if (!predef) {
    return false;
  }

  // Value should always be string:
  value = value.toString();

  const values = predef[key];

  if (!values) {
    return false;
  }

  if (typeof values === "string" || values instanceof String) {
    return value == values;
  }
  // We got an array?
  console.log("Check if value", values, value);
  return values.indexOf(value) >= 0;
};

export default (templateList, options) => {
  const [filters, setFilters] = useState([]);
  const { t } = useTranslation();
  const { getProductByUuid } = usePriceList();
  const history = useHistory();
  const location = useLocation();

  console.log("Use tmeplate filters", templateList);

  const toggleFilterOption = (type, value) => {
    const filterTypes = filters.map((filterType) => {
      if (filterType.type === type) {
        const options = filterType.options.map((option) => {
          if (option.value === value) {
            return { ...option, checked: !option.checked };
          }
          return option;
        });
        return { ...filterType, options: options };
      }
      return filterType;
    });

    let url = "";
    for (const filter of filterTypes) {
      for (const option of filter.options) {
        if (option.checked) {
          if (url) {
            url += "&";
          }
          url += filter.type + "[]=" + encodeURIComponent(option.value);
        }
      }
    }

    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has("category")) {
      url += "&category=" + encodeURIComponent(searchParams.get("category"));
    }
    history.replace(location.pathname + "?" + url);

    // it's a complete new state!
    //setFilters(filterTypes);
  };

  useEffect(() => {
    if (!templateList) {
      return;
    }

    const filterList = [];

    if (options.filters.indexOf("formats") >= 0) {
      const formatOptions = getUniqueValuesByKey(
        templateList.templates,
        (t) => t.product.formatSize,
      ).map((option) => {
        const checked = isChecked("formats", options?.predef, option);
        return {
          name: option,
          value: option,
          checked: checked,
        };
      });

      if (formatOptions.length > 1) {
        filterList.push({
          title: t("Format"),
          type: "formats",
          key: "formats",
          filterFunction: (template, value) => {
            return template.product.formatSize == value;
          },
          options: formatOptions,
        });
      }
    }

    if (options.filters.indexOf("texts") >= 0) {
      const yesChecked = isChecked("texts", options?.predef, "1");
      const noChecked = isChecked("texts", options?.predef, "0");
      filterList.push({
        title: t("With text"),
        type: "texts",
        key: "texts",
        filterFunction: (template, value) => {
          console.log("The filter value is", value);
          return template.hasUserText == value;
        },
        options: [
          {
            name: t("Yes"),
            value: "1",
            checked: yesChecked,
          },
          {
            name: t("No"),
            value: "0",
            checked: noChecked,
          },
        ],
      });
    }

    if (options.filters.indexOf("images") >= 0) {
      const numImagesOptions = getUniqueValuesByKey(
        templateList.templates,
        (t) => t.numUserImages,
      )
        .sort((a, b) => a - b)
        .map((images) => {
          const checked = isChecked("images", options?.predef, images);
          return {
            name: images,
            value: images,
            checked: checked,
          };
        });

      if (numImagesOptions.length > 1) {
        filterList.push({
          title: t("Images"),
          type: "images",
          key: "images",
          filterFunction: (template, value) => {
            return template.numUserImages == value;
          },
          options: numImagesOptions,
        });
      }
    }

    if (options.filters.indexOf("pages")) {
      const pagesOptions = getUniqueValuesByKey(
        templateList.templates,
        (t) => t.numUserParts,
      ).map((pages) => {
        const checked = isChecked("pages", options?.predef, pages);

        return {
          name: pages,
          value: pages,
          checked: checked,
        };
      });

      if (pagesOptions.length > 1) {
        filterList.push({
          title: t("Pages"),
          type: "pages",
          key: "pages",
          filterFunction: (template, value) => {
            return template.numUserParts === value;
          },
          options: pagesOptions,
        });
      }
    }

    /*
    const categoriesOptions = getUniqueValuesByKey(
      templateList.templates,
      'categories'
    ).map((category) => {
      return {
        name: t(category),
        value: category,
        checked: false
      };
    });


    if (categoriesOptions.length > 1) {
      filterList.push({
        title: t("Categories"),
        type: "categories",
        key: 'categories',
        filterFunction: (template, value) => {
          return template.categories.indexOf(value) >= 0
        },
        options: categoriesOptions
      });
    }

    const categoriesOptions = getUniqueValuesByKey(
      templateList.templates,
      "productId"
    ).map((productId) => {
      return {
        name: "Product " + productId,
        value: productId,
        checked: false
      };
    });

    filterList.push({
      title: "Products",
      type: "products",
      key: "productId",
      options: categoriesOptions
    });

    const pagesOptions = getUniqueValuesByKey(
      templateList.templates,
      "pages"
    ).map((productId) => {
      return {
        name: "Pages " + productId,
        value: productId,
        checked: false
      };
    });

    filterList.push({
      title: "Images",
      type: "images",
      key: "images",
      options: imagesOptions
    });

    filterList.push({
      title: "Text",
      type: "text",
      key: "hasUserTextField",
      options: [
        {
          name: "Has text field",
          value: true,
          checked: false
        }
      ]
    });
    */
    setFilters(filterList);
  }, [templateList, options]);

  return [filters, toggleFilterOption];
};
